module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@2x-e493118bc2f986615dfd8fd1b453636e.png";